import React from 'react';
import { FormattedMessage } from 'react-intl';

import ProfilePopup from './ProfilePopup';

const ProfileErrorPopup = (props) => {
  return (
    <ProfilePopup
      bodyMsg={<FormattedMessage id="profile.422.error.info" />}
      submitMsg={<FormattedMessage id="action.confirm.welcome.msg" />}
      singleButton
      {...props}
    />
  );
};

export default ProfileErrorPopup;
